<template>
  <div class="cms-view__content">
    <div class="cms-view__element">
    <div class="container pt-6 my-6 has-background-light">
      <b-carousel :pause-hover="false" :arrow="false">
        <b-carousel-item>
          <section :class="`hero is-small is-light`">
            <div class="hero-body has-text-centered has-text-primary">
              <h1 class="title has-text-primary">"MeltWerk: empfehlenswert alternativlos"</h1>
              <p class="title is-4 pb-4">
                3d-drucken.de
              </p>
            </div>
          </section>
        </b-carousel-item>
        <b-carousel-item>
          <section :class="`hero is-small is-light`">
            <div class="hero-body has-text-centered has-text-primary">
              <h1 class="title has-text-primary"> "MeltWerk [...] stellt in Deutschland den preiswertesten und unkompliziertesten
                Druckdienst für 3D-Objekte dar."</h1>
              <p class="title is-4 pb-4">
                3d-drucker-world.de
              </p>
            </div>
          </section>
        </b-carousel-item>
        <b-carousel-item>
          <section :class="`hero is-small is-light`">
            <div class="hero-body has-text-centered has-text-primary">
              <h1 class="title has-text-primary"> "MeltWerk hat den 3D-Druck-Markt analysiert und verstanden, wo die Herausforderungen
                liegen."</h1>
              <p class="title is-4 pb-4">
                3DPrint.com
              </p>
            </div>
          </section>
        </b-carousel-item>
      </b-carousel>
    </div>
      <b-icon
          pack="fas"
          icon="user"
          size="is-small" type="is-primary">
      </b-icon>
    </div>
    <div class="cms-view__element">
      <div class="container pt-6 is-tablet">
        <h1 class="title is-3 has-text-primary">MeltWerk Fotogalerie</h1>
        <b-carousel :indicator-inside="false" height="600" :pause-hover="false" :arrow="false">
          <b-carousel-item>
            <b-image class="image" src="https://www.meltwerk.com/de/grafix/photos/02.jpg"></b-image>
          </b-carousel-item>
          <b-carousel-item>
            <b-image class="image" src="https://www.meltwerk.com/de/grafix/photos/03.jpg"></b-image>
          </b-carousel-item>
          <b-carousel-item>
            <b-image class="image" src="https://www.meltwerk.com/de/grafix/photos/04.jpg"></b-image>
          </b-carousel-item>
          <b-carousel-item>
            <b-image class="image" src="https://www.meltwerk.com/de/grafix/photos/05.jpg"></b-image>
          </b-carousel-item>        <b-carousel-item>
          <b-image class="image" src="https://www.meltwerk.com/de/grafix/photos/06.jpg"></b-image>
        </b-carousel-item>
        </b-carousel>
      </div>
    </div>

    <div class="cms-view__element hero-banner">
      <div class="hero hero-banner">
      <img alt="Hero Banner" src="https://www.meltwerk.com/de/grafix/bg_3.jpg" class="hero-banner__image">
      <div class="hero-body hero-banner__content">
      <div class="container pt-6">
        <h1 class="title is-3 has-text-primary has-text-left">Unschlagbar günstig bei bester Qualität - wie schafft ihr das?</h1>
        <div class="columns is-centered is-multiline">
          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_1.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  SCHLANKE PROZESSE<br>
                  Weniger Arbeit für uns, günstige Preise für dich.
                </div>
              </div>
            </div>
          </div>
          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_2.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  KEINE EXTRAS UND KEINE EXTRAKOSTEN<br>
                  1 Technologie, 1 Material, 1 Farbe
                </div>
              </div>
            </div>

          </div>
        </div>
        <h1 class="title is-4 has-text-primary mt-6">Einfach und transparent.</h1>
        <div class="columns is-centered is-multiline">
          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_4.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  EINFACHE BEDIENUNG<br>
                  Bestellung innerhalb weniger Minuten.
                </div>
              </div>
            </div>
          </div>

          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_5.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  EINFACH DRUCKEN<br>
                  Keine Registrierung notwendig.
                </div>
              </div>
            </div>

          </div>

          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_6.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  KEINE UNERWARTETEN KOSTEN<br>
                  Dein Preis wird in Echtzeit berechnet.
                </div>
              </div>
            </div>
          </div>

          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_7.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  SICHERHEIT<br>
                  Du bist der Besitzer deiner Modelldaten.
                </div>
              </div>
            </div>


          </div>
        </div>
        <h1 class="title is-4 has-text-primary mt-6">Dein Projekt verdient die beste
          Technologie!</h1>

        <div class="columns is-centered is-multiline">

          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_8.png">

                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  DAS DRUCKVERFAHREN<br>
                  Selektives Lasersintern (SLS)<br>
                  Die High-End-Technologie des 3D-Drucks.<br>
                  <br>
                </div>
              </div>
            </div>

          </div>

          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_9.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  UNIVERSELL EINSETZBAR<br>
                  Hohes Detaillevel - Komplexe Designs ohne Stützmaterialien - Für bewegliche Bauteile geeignet - Hohe
                  Stabilität - Leicht rauhe Oberfläche
                </div>
              </div>
            </div>
          </div>


          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_10.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  DIE SPIELWIESE<br>
                  Min. Wandstärke: 1 mm / Min. Details: 0.7 mm<br>
                  Größe (Bounding Box): B + T + H = max. 360 mm<br>
                  Min. Löcher: ∅ 1.0 mm
                </div>
              </div>
            </div>


          </div>

          <div class="column is-half">
            <div class="media">
              <div class="media-left">
                <div class="image is-48x48">
                  <img src="https://meltwerk.de/grafix/page_2_gfx_11.png">
                </div>
              </div>
              <div class="media-content">
                <div class="page_2_infotext">
                  DER WERKSTOFF<br>
                  Hochwertiges Polyamid PA 12, klassisch weiß<br>
                  Eigenschaften: zerreißfest, abriebfest, unempfindlich bei Spannungsrisskorrosion
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "MeltwerkLegacyContent"
}
</script>

<style scoped lang="scss">
.hero-banner {
  position: relative;
  overflow: hidden;

&__image {
   position: absolute;
   width: 100%;
   height: 100%;
   object-fit: cover;
 }

&__content {
   z-index: $z-index-hero-content;
 }


&:before {
   content: "";
   position: absolute;
   top: 0;
   bottom: 0;
   left: 0;
   right: 0;
   z-index: $z-index-hero-content - 2;
 }


}
</style>